import React from 'react';

import { PolicyContainer, PolicySection } from './CancellationPolicy.styled';
import { Text } from 'components/v2/Typography/Text';
import { currencyNumberFormat } from 'utilities/number-format';

import { CancellationPolicyProps } from './CancellationPolicy.types';
import { NavigatorEmail } from './NavigatorEmail';
import { NavigatorNumber } from './NavigatorNumber';

const getNoCancelNorRescheduleVariant = (emailBody: string) => {
  return (
    <p>
      <Text>
        This appointment cannot be canceled nor rescheduled in the Patient Portal. Please call us
        at{' '}
      </Text>
      <NavigatorNumber />
      <Text> or email us at </Text>
      <NavigatorEmail emailBody={emailBody} />
      <Text> to cancel or reschedule your appointment.</Text>
    </p>
  );
};

const getLateCancelWindowVariant = (emailBody: string) => {
  return (
    <p>
      <Text>
        To reschedule or cancel within the late cancellation window, or if you have any questions,
        email us at{' '}
      </Text>
      <NavigatorEmail emailBody={emailBody} />
      <Text> or call us at </Text>
      <NavigatorNumber />
      <Text>.</Text>
    </p>
  );
};

export const CancellationPolicy = ({
  emailBody,
  noCancelNorRescheduleVariant,
  lateCancelWindowHours,
  lateCancelFeeCents,
  noShowFeeCents
}: CancellationPolicyProps): JSX.Element => {
  const hasLateCancelFeeDetails = lateCancelWindowHours != null && lateCancelFeeCents != null;

  return (
    <PolicyContainer>
      {noCancelNorRescheduleVariant
        ? getNoCancelNorRescheduleVariant(emailBody)
        : getLateCancelWindowVariant(emailBody)}
      <PolicySection>
        <Text tag="p" fontStyle="semibold">
          Cancellation/No-Show Policy:
        </Text>
        {!noCancelNorRescheduleVariant && (
          <Text tag="p">
            To reschedule or cancel: Please make any changes through the patient portal.
          </Text>
        )}
        <Text tag="p">
          {hasLateCancelFeeDetails ? (
            <>
              Late Cancellation: If you cancel within {lateCancelWindowHours} hours of your
              appointment, a {currencyNumberFormat(lateCancelFeeCents / 100)} late cancellation fee
              may apply.
            </>
          ) : (
            'Late Cancellation: Late cancellations may be subject to a fee.'
          )}
        </Text>
        <Text tag="p">
          {noShowFeeCents != null ? (
            <>
              No-Show: If you miss your appointment without canceling, a{' '}
              {currencyNumberFormat(noShowFeeCents / 100)} no-show fee will apply.
            </>
          ) : (
            'No-Show: If you miss your appointment without canceling, a no-show fee may apply.'
          )}
        </Text>
      </PolicySection>
    </PolicyContainer>
  );
};
